import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { appendSerialisedHttpParams, ENVIRONMENT, ReportOutputFormat, ReportOutputFormatName, ReportRunService, ReportSpecification, ReportSpecificationService } from '@scisys-uim/uim-common';
import { Ranger } from 'assets-model';
import { Observable } from 'rxjs';
import { FirearmAssignmentService, ReturnFirearmToStorageData } from '../../firearm_assignment/model/firearm-assignment.service';
import { RangerServiceBase } from './ranger.service.base';

export interface RangerStoreFirearmsData extends ReturnFirearmToStorageData {
  rangerId: number;
}

export interface RangerSetToPendingData extends RangerStoreFirearmsData {
}

export interface RangerOnLeaveData extends RangerStoreFirearmsData {
}

export interface RangerLeavingData extends RangerStoreFirearmsData {
}

@Injectable({
  providedIn: 'root'
})
export class RangerService extends RangerServiceBase {
  constructor(protected firearmAssignmentService: FirearmAssignmentService,
    protected reportRunService: ReportRunService,
    protected reportSpecificationService: ReportSpecificationService,
    http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(http, environment);
  }

  rangerActivate(rangerId: number): Observable<Ranger> {
    return this.deserialise(
      this.http.post<Ranger>(this.serviceBaseUrl + '/rangerActivate/' + rangerId, null));
  }

  rangerSetToPending(item: RangerSetToPendingData): Observable<Ranger> {
    return this.deserialise(
      this.http.post<Ranger>(this.serviceBaseUrl + '/rangerSetToPending', item));
  }

  rangerOnLeave(item: RangerOnLeaveData): Observable<Ranger> {
    return this.deserialise(
      this.http.post<Ranger>(this.serviceBaseUrl + '/rangerOnLeave', item));
  }

  rangerReturnFromLeave(rangerId: number): Observable<Ranger> {
    return this.deserialise(
      this.http.post<Ranger>(this.serviceBaseUrl + '/rangerReturnFromLeave/' + rangerId, null));
  }

  rangerLeaving(item: RangerLeavingData): Observable<Ranger> {
    return this.deserialise(
      this.http.post<Ranger>(this.serviceBaseUrl + '/rangerLeaving', item));
  }

  notifyPoliceOfRangerAddressChange(rangerId: number): Observable<Ranger> {
    return this.deserialise(
      this.http.post<Ranger>(this.serviceBaseUrl + '/notifyPoliceOfRangerAddressChange/' + rangerId, null));
  }

  public exportRangerAssignedFirearmsReport(rangerId: number, format: ReportOutputFormatName, download: boolean): void {
    var filters = {
      rangerId: rangerId,
    }
    var params = appendSerialisedHttpParams(filters);
    params = this.reportRunService.reportGeneralHttpParams({ name: format, downloadOnly: false }, download, params);
    return this.reportRunService.reportAction(this.serviceBaseUrl + '/rangerAssignedFirearmsReport', params);
  }

  
  public exportFirearmsByPoliceAuthorityReport(filters: any, format: ReportOutputFormatName, download: boolean): void {
    var params = appendSerialisedHttpParams(filters);
    params = this.reportRunService.reportGeneralHttpParams({ name: format, downloadOnly: false }, download, params);
    return this.reportRunService.reportAction(this.serviceBaseUrl + '/firearmsByPoliceAuthorityReport', params);
  }

}



